import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = { index: Number };

  select(event) {
    event.preventDefault();
    const selectedTab = event.currentTarget;
    const targetId =
      selectedTab.dataset.tabsPanelParam ||
      (selectedTab.getAttribute("href") || "").replace("#", "");

    if (!targetId) return;

    this.tabTargets.forEach((tab) => {
      const isActive = tab === selectedTab;
      tab.classList.toggle("active", isActive);
      tab.setAttribute("aria-selected", isActive);
    });

    this.panelTargets.forEach((panel) => {
      const isActive = panel.id === targetId;
      panel.classList.toggle("active", isActive);
      panel.classList.toggle("show", isActive);
    });

    this.indexValue = this.tabTargets.indexOf(selectedTab);
    this.dispatch("changed", { detail: { tab: selectedTab, targetId } });
  }
}
